import _classCallCheck from "/home/rich/projects/django-doctor-website/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/home/rich/projects/django-doctor-website/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/rich/projects/django-doctor-website/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/rich/projects/django-doctor-website/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/home/rich/projects/django-doctor-website/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _wrapNativeSuper from "/home/rich/projects/django-doctor-website/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
import { request } from '@octokit/request';
import { getUserAgent } from 'universal-user-agent';
var VERSION = "4.5.0";

var GraphqlError = /*#__PURE__*/function (_Error) {
  _inherits(GraphqlError, _Error);

  function GraphqlError(request, response) {
    var _this;

    _classCallCheck(this, GraphqlError);

    var message = response.data.errors[0].message;
    _this = _possibleConstructorReturn(this, _getPrototypeOf(GraphqlError).call(this, message));
    Object.assign(_assertThisInitialized(_assertThisInitialized(_this)), response.data);
    _this.name = "GraphqlError";
    _this.request = request; // Maintains proper stack trace (only available on V8)

    /* istanbul ignore next */

    if (Error.captureStackTrace) {
      Error.captureStackTrace(_assertThisInitialized(_assertThisInitialized(_this)), _this.constructor);
    }

    return _this;
  }

  return GraphqlError;
}(_wrapNativeSuper(Error));

var NON_VARIABLE_OPTIONS = ["method", "baseUrl", "url", "headers", "request", "query", "mediaType"];

function graphql(request, query, options) {
  options = typeof query === "string" ? options = Object.assign({
    query: query
  }, options) : options = query;
  var requestOptions = Object.keys(options).reduce(function (result, key) {
    if (NON_VARIABLE_OPTIONS.includes(key)) {
      result[key] = options[key];
      return result;
    }

    if (!result.variables) {
      result.variables = {};
    }

    result.variables[key] = options[key];
    return result;
  }, {});
  return request(requestOptions).then(function (response) {
    if (response.data.errors) {
      throw new GraphqlError(requestOptions, {
        data: response.data
      });
    }

    return response.data.data;
  });
}

function withDefaults(request$1, newDefaults) {
  var newRequest = request$1.defaults(newDefaults);

  var newApi = function newApi(query, options) {
    return graphql(newRequest, query, options);
  };

  return Object.assign(newApi, {
    defaults: withDefaults.bind(null, newRequest),
    endpoint: request.endpoint
  });
}

var graphql$1 = withDefaults(request, {
  headers: {
    "user-agent": "octokit-graphql.js/".concat(VERSION, " ").concat(getUserAgent())
  },
  method: "POST",
  url: "/graphql"
});

function withCustomRequest(customRequest) {
  return withDefaults(customRequest, {
    method: "POST",
    url: "/graphql"
  });
}

export { graphql$1 as graphql, withCustomRequest };